import {z} from 'zod';

import {omneticApi} from '@dms/api/base';

import {
  BranchPreselectionSettings,
  BranchPreselectionSettingsSchema,
  GetBranchPreselectionApiArg,
  PutBranchPreselectionApiArg,
} from './types';

export const branchPreselectionApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getBranchPreselection: build.query<BranchPreselectionSettings, GetBranchPreselectionApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/settings/${queryArg.recordType}/branch-preselection`,
      }),
      extraOptions: {
        requestSchema: z.void(),
        responseSchema: BranchPreselectionSettingsSchema,
      },
    }),
    putBranchPreselection: build.mutation<void, PutBranchPreselectionApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/settings/${queryArg.recordType}/branch-preselection`,
        method: 'PUT',
        body: queryArg.branchPreselectionSettingsRequestBody,
      }),
      extraOptions: {
        requestSchema: z.void(),
        responseSchema: z.void(),
      },
      onQueryStarted: async (queryArg, {dispatch, queryFulfilled}) => {
        const patchResult = dispatch(
          branchPreselectionApi.util.updateQueryData(
            'getBranchPreselection',
            {recordType: queryArg.recordType},
            () => queryArg.branchPreselectionSettingsRequestBody
          )
        );
        await queryFulfilled.catch(patchResult.undo);
      },
    }),
  }),
});

export const {useGetBranchPreselectionQuery, usePutBranchPreselectionMutation} =
  branchPreselectionApi;
